<template>
  <div class="table-topic">
    <div class="row m-b-10">
      <div class="col-md-12">
        <h6>
          Topik Media Sosial
          <button
            aria-label=""
            v-on:click="addTopik"
            class="btn btn-success text-white btn-icon-left pull-right"
            type="button"
          >
          <i class="bi bi-plus"></i> <span class="">Tambah Topik</span>
          </button>
        </h6>
      </div>
    </div>
    <table class="table table-bordered" id="daftar_keyword">
      <thead>
        <tr>
          <th width="5%">No</th>
          <th>Topik</th>
          <th width="20%">Aksi</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="data_topic == null">
          <td colspan="3">
            <loader-component />
          </td>
          <td style="display: none"></td>
          <td style="display: none"></td>
        </tr>
      </tbody>
    </table>

    <div v-if="tipe_project == 1" class="row m-b-10">
      <div class="col-md-12">
        <h6>Topik Media Konvensional</h6>
      </div>
    </div>
    <table
      v-if="tipe_project == 1"
      class="table table-bordered"
      id="daftar_keyword_medkon"
    >
      <thead>
        <tr>
          <th width="5%">No</th>
          <th>Topik</th>
          <th width="20%">Aksi</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="data_topic_formed == null">
          <td colspan="3">
            <loader-component />
          </td>
          <td style="display: none"></td>
          <td style="display: none"></td>
        </tr>
      </tbody>
    </table>
    <floating-loader-component v-if="is_loading" />
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
    />
  </div>
</template>

<script>
import $ from "jquery";
import swal from "sweetalert";
import notif from "@/assets/js/notif.js";
import loader_component from "@/views/components/loader.vue";
import floating_loader from "@/views/components/floating_loader.vue";
$.pgNotification = notif;

import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_topic from "@/views/components/settings/keyword/modal_add_topic.vue";
import modal_edit_topic from "@/views/components/settings/keyword/modal_edit_topic.vue";

export default {
  name: "table_topic",
  components: {
    "modal-dynamic-component": modal_dynamic,
    "loader-component": loader_component,
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      data_topic: null,
      data_topic_formed: null,
      isError: false,
      no_tabel: 1,
      currentModal: null,
      table: null,
      table_formed: null,
      modal_key: 0,
      modal_data: [],
      id_project: this.$store.getters.user.id_project,
      tipe_project: this.$store.getters.user.project.project_detail.tipe,
      is_loading: false,
    };
  },
  methods: {
    getTopic: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status == 204) {
            self.data_topic = {};
            self.isError = false;
          } else {
            self.data_topic = response.data.socmed;
            self.isError = false;
            let counter = 1;
            let btn;
            self.table.clear().draw();

            if (self.tipe_project == 1) {
              self.data_topic_formed = response.data.formed;
              self.table_formed.clear().draw();
            }

            for (let index in self.data_topic) {
              btn =
                '<button class="btn btn-sm btn-complete ch m-r-5" data-tipe="1"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-danger del" data-tipe="1"><i class="bi bi-trash"></i></button>';
              self.table.row
                .add([counter, self.data_topic[index], btn])
                .node().id = index;
              self.table.draw(false);
              counter++;
            }

            if (self.tipe_project == 1) {
              counter = 1;
              if (Object.entries(self.data_topic_formed).length > 0) {
                for (let index in self.data_topic_formed) {
                  btn =
                    '<button class="btn btn-sm btn-complete ch m-r-5" data-tipe="2"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-danger del" data-tipe="2"><i class="bi bi-trash"></i></button>';
                  self.table_formed.row
                    .add([counter, self.data_topic_formed[index], btn])
                    .node().id = index;
                  self.table_formed.draw(false);
                  counter++;
                }
              }
            }
          }
        })
        .catch(function (err) {
          self.resp = err.response;
          self.isError = true;
        });
    },
    deleteTopic: function (id, tipe) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Menghapus topik akan menyebabkan semua keyword yang ada pada topik tersebut terhapus.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          this.is_loading = true;
          let params = {
            _id: id,
            tipe: parseInt(tipe),
          };
          let api = process.env.VUE_APP_API_URL + "new-topic-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                if (tipe == 1) {
                  delete self.data_topic[id];
                  self.table
                    .row("#" + id)
                    .remove()
                    .draw(false);
                } else {
                  delete self.data_topic_formed[id];
                  self.table_formed
                    .row("#" + id)
                    .remove()
                    .draw(false);
                }

                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Topik berhasil dihapus.',
                    position: "top",
                    timeout: 4000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus topik.',
                  position: "top",
                  timeout: 4000,
                  type: "danger",
                })
                .show();
            })
            .finally(() => {
              this.is_loading = false;
            });
        }
      });
    },
    addTopik: function () {
      this.currentModal = {};
      let data = [];
      data.push({
        callback: this.getTopic,
      });
      this.modal_data = data;
      this.currentModal.title = "Tambah Topik";
      this.currentModal.subtitle = "Silahkan masukan nama topik";
      this.currentModal.component = modal_add_topic;
      this.modal_key++;
    },
    editTopic: function (id, topic, tipe) {
      this.currentModal = {};
      let data = [];
      data["id_topic"] = id;
      data["topic"] = topic;
      data["tipe"] = parseInt(tipe);
      data["callback"] = this.getTopic;
      this.currentModal.title = "Ubah Topik";
      this.currentModal.subtitle = "Silahkan masukan nama topik";
      this.currentModal.component = modal_edit_topic;
      this.modal_data = data;
      this.modal_key++;
    },
  },
  mounted: function () {
    this.table = $("#daftar_keyword").DataTable();
    let self = this;
    $("#daftar_keyword tbody").on("click", ".del", function () {
      var tr = $(this).closest("tr");
      let tipe = $(this).attr("data-tipe");
      let id = $(tr).attr("id");
      self.deleteTopic(id, tipe);
    });
    $("#daftar_keyword tbody").on("click", ".ch", function () {
      let tipe = $(this).attr("data-tipe");
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      var data = self.table.row(tr).data();
      self.editTopic(id, data[1], tipe);
    });
    if (this.tipe_project == 1) {
      this.table_formed = $("#daftar_keyword_medkon").DataTable();
      $("#daftar_keyword_medkon tbody").on("click", ".del", function () {
        let tipe = $(this).attr("data-tipe");
        var tr = $(this).closest("tr");
        let id = $(tr).attr("id");
        self.deleteTopic(id, tipe);
      });
      $("#daftar_keyword_medkon tbody").on("click", ".ch", function () {
        let tipe = $(this).attr("data-tipe");
        var tr = $(this).closest("tr");
        let id = $(tr).attr("id");
        var data = self.table_formed.row(tr).data();
        self.editTopic(id, data[1], tipe);
      });
    }

    this.getTopic();
  },
};
</script>